export const RAIL_HEIGHT = 10;
export const KNOB_SIZE = RAIL_HEIGHT * 2;
export const KNOB_INNER_SIZE = Math.trunc(KNOB_SIZE / 2);

export const KNOB_STEP_WIDTH = 3;

export const RAIL_COLOR = 'rgb(209, 213, 219)';
export const RAIL_INSET_SHADOW = `inset 0px 0px 4px 0px rgba(0, 0, 0, 0.25)`;
